import cssVariables from 'tfs.css-variables'
import TableStyles from '../Table/Table.styles'

export default {
  wrapper: {
    paddingBottom: '2rem',
    backgroundColor: cssVariables.colorWhite,
    borderRadius: '0.5rem',
    width: cssVariables.containerWidth,
    margin: '2rem auto 0',
  },
  header: {
    padding: '2rem 2rem 1rem',
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    fontSize: '1.25rem',
    color: cssVariables.colorBlue,
    textAlign: 'left',
    margin: 0,
  },
  field: {
    height: '2.5rem',
    width: '2.5rem',
    fontSize: '1.25rem',
    textAlign: 'center',
    padding: '0',
  },
  row: TableStyles.row,
  cel: {
    flexBasis: '10rem',
    padding: '1.5rem 0',
    fontSize: '1.25rem',
    alignSelf: 'center',
  },
  cellMerger: {
    display: 'flex',
    alignItems: 'center',
  },
  rowError: {
    display: 'flex',
    flexFlow: 'row',
    padding: '1rem 2rem',
    borderBottom: `1px solid ${cssVariables.colorGrayE}`,
    justifyContent: 'space-between',
    backgroundColor: cssVariables.colorErrorBackground,
    boxShadow: 'inset 0 -0.125rem 0.25rem 0 rgba(0,0,0,0.2)',
    borderRadius: '0 0 0.5rem 0.5rem',
  },
}
